import { TWidget } from '@libs/types';
import { useBehavior, useCheckBox } from '@libs/hooks';
import React from 'react';
import { TCoreInputData } from '../types/data';
import { useThemeHook } from '../hooks/themeHook';
import { TCoreCheckboxOptions } from '../types/options';
import { getCommonStyles, getAlignment } from '../utils/styles';
import styles from './checkbox.module.css';

type TCoreCheckbox = {
    widget: TWidget<TCoreInputData, TCoreCheckboxOptions>;
};

const CoreCheckbox = ({ widget }: TCoreCheckbox) => {
    const { isDisabled, isHidden } = useBehavior(widget);
    const { palette } = useThemeHook(widget);
    const { handleChange, isChecked } = useCheckBox(widget, { skipValidation: true });

    const size = palette?.size ? `${palette.size}px` : '18px';
    const color = isChecked ? palette.main : palette.onSurfaceVariant;
    const checkboxClassName = [styles.checkbox, isChecked && styles.checked, isDisabled && styles.disabled].filter(Boolean).join(' ');

    return (
        <div style={{ ...getCommonStyles(palette, isHidden), ...getAlignment(palette?.alignment) }}>
            <label className={checkboxClassName} style={{ color }}>
                <input
                    type="checkbox"
                    data-test={widget?.uid}
                    className={styles.input}
                    disabled={isDisabled}
                    checked={isChecked}
                    onChange={handleChange}
                />
                <span className={styles.box} style={{ width: size, height: size }}>
                    <svg className={styles.checkmark} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                            d="M17.2559 4.41073C17.5813 4.73617 17.5813 5.26381 17.2559 5.58925L8.08926 14.7559C7.76382 15.0813 7.23618 15.0813 6.91074 14.7559L2.74408 10.5892C2.41864 10.2638 2.41864 9.73616 2.74408 9.41074C3.06952 9.08532 3.59715 9.08532 3.92259 9.41074L7.5 12.9882L16.0774 4.41073C16.4028 4.0853 16.9305 4.0853 17.2559 4.41073Z"
                            fill={palette.onMain ?? '#FFFFFF'}
                        />
                    </svg>
                </span>
            </label>
        </div>
    );
};
export { CoreCheckbox };
